<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    @import "../common/style/variables";
    .processor {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .icon-process + span {
        font-size: 15px;
    }
    .icon-process {
        width: 30px * @scaleRate;
        margin-right: 10px * @scaleRate;
    }
    .floor {
        display: flex;
        align-items: center;
    }
    .line {
        width: 26.38%;
        margin: 0 30px;
        height: 1px;
        background-color: #999999;
    }
    .line.active {
        background-color: #4B89F3;
    }
</style>

<template>
    <div class="processor">
        <div class="floor">
            <img class="icon-process" v-if="step < 2" src="../common/image/one_icon_full.png" alt="">
            <img class="icon-process" v-else src="../common/image/complete_icon.png" alt="">
            <span>上传头像</span>
        </div>
        <div class="line" :class="{active: step !== 1}"></div>
        <div class="floor">
            <img class="icon-process" v-if="step === 2" src="../common/image/two_icon_full.png" alt="">
            <img class="icon-process" v-if="step === 1" src="../common/image/two_icon.png" alt="">
            <img class="icon-process" v-if="step === 3" src="../common/image/complete_icon.png" alt="">
            <span>设置密码</span>
        </div>
        <div class="line" :class="{active: step === 3}"></div>
        <div class="floor">
            <img class="icon-process" v-if="step === 3" src="../common/image/three_icon_full.png" alt="">
            <img class="icon-process" v-else src="../common/image/three_icon.png" alt="">
            <span>审核中</span>
        </div>
    </div>
</template>

<script>
  export default {
    data () {
      return {
      }
    },
    props: {
      step: {
        type: Number,
        default: 1
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/process.vue